import * as React from 'react';

import styled from '@emotion/styled';
import { L } from '../../../../../lib/i18n';
import { Space } from '@app/api/public/PropertiesApi';
import { Checkbox } from '../../../../../components/Checkbox/Checkbox';
import { MultiSelect } from '../../../../../components/Dropdown/MultiSelect';
import DropdownFlexContainer from './DropdownFlexContainer';

const Container = styled.div({ paddingRight: '10px', width: '160px' });

interface Props {
    filter: { space?: string[] };
    setFilter: (filter: any) => void;
    store: { spaces: Space[]; loadAddonSuppliers(projectId?: string): Promise<void> };
}

export const FilterSpace = (props: Props) => {
    const name = 'space';

    const handleOnChange = value => {
        event?.preventDefault();
        props.setFilter({
            ...props.filter,
            [name]: [...new Set<string>(value?.flatMap(id => id.value))]
        });
    };

    const options = props.store.spaces.map(v => ({
        value: v.name,
        label: (
            <DropdownFlexContainer>
                <Checkbox onChange={() => handleOnChange} checked={props.filter[name]?.includes(v.name) || false} />
                <span>{v.name}</span>
            </DropdownFlexContainer>
        )
    }));

    const selectAll = [
        {
            value: props.store.spaces?.map(space => space.name),
            label: ' Välj alla'
        },
        ...options
    ];

    return (
        <Container>
            <MultiSelect
                isMulti={true}
                isClearable
                value={props.filter[name]?.map(space_name => ({
                    value: space_name,
                    label: props.store.spaces.find(({ name: sname }) => sname === space_name)?.name
                }))}
                onChange={handleOnChange}
                name={name}
                label={L(name)}
                options={selectAll}
            />
        </Container>
    );
};
